<template>
	<section class="page page-extras-shotclock">
		<!-- Do nothing -->
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageExtrasShotClock extends PageBase {}
</script>

<style lang="scss">
	.page-extras-shotclock {
		// Not implemented
	}
</style>
